import { addCallback, setGlobal } from 'reactn';

const initGlobalState = () => {
    const storedGlobalState = localStorage.getItem('globalState') ? JSON.parse(localStorage.getItem('globalState')) : {};
    const globalState = {
        ...{
            merchantGroup: {},
            activeConceptId: null,
            activeUser: {},
            activeConcept: {},
            sidebarOpen: true,
            sidebarSelectedIndex: 0,
            uploadLocationsComplete: false,
            redirectToSecure: false,
            siteLoading: true
        },
        ...storedGlobalState,
        ...{
            concepts: {}
        }
    };
    setGlobal(globalState);
    addCallback((global) => {
        localStorage.removeItem('globalState');
        localStorage.setItem('globalState', JSON.stringify(global));
        return null;
    });
    return globalState;
};

export default initGlobalState;